import React, { Component } from "react";

export default class Contact extends Component {
	constructor() {
      super();
			this.state={
        formData: {
          name: '',
          email: '',
          phone: '',
          message: ''
        },
        isSubmitting: false,
        isSubmitted: false
      }
	}

	handleInputChange = (e) => {
		const { name, value } = e.target;
		this.setState(prevState => ({
			formData: {
				...prevState.formData,
				[name]: value
			}
		}));
	}

	handleSubmit = async (e) => {
		e.preventDefault();
		this.setState({ isSubmitting: true });

		try {
			const response = await fetch('https://api.web3forms.com/submit', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					access_key: '5ce75685-127c-4dd4-8f96-f82def746195',
					...this.state.formData
				})
			});

			if (response.ok) {
				this.setState({ 
					isSubmitted: true,
					isSubmitting: false,
					formData: { name: '', email: '', phone: '', message: '' }
				});
			} else {
				throw new Error('Submission failed');
			}
		} catch (error) {
			console.error('Error submitting form:', error);
			this.setState({ isSubmitting: false });
		}
	}

	render() {
		return (
      <div>
        {/* Background Image - Adapts to Form Height */}
        <div style={{
          position: "relative",
          backgroundImage: "url('/images/portfolio/garage-1.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "80px 0"
        }}>
          {/* Overlay to darken the background */}
          <div style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.3)"
          }}></div>

          {/* Yelp Banner - Left Side */}
          <div style={{
            position: "absolute",
            left: "0px",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 100
          }}>
            <a href="https://www.yelp.com/biz/pacific-garage-doors-half-moon-bay-2" target="_blank" rel="noopener noreferrer" style={{textDecoration: "none"}}>
              <div className="yelp-background" style={{
                padding: "20px 15px",
                borderRadius: "8px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                cursor: "pointer",
                transition: "transform 0.3s ease, box-shadow 0.3s ease"
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.05)";
                e.target.style.boxShadow = "0 6px 25px rgba(0,0,0,0.4)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
                e.target.style.boxShadow = "0 4px 20px rgba(0,0,0,0.3)";
              }}>
                <img src="/images/yelp-logo.png" alt="Yelp" style={{
                  width: "40px",
                  height: "40px",
                  marginBottom: "10px"
                }} />
                <div className="white" style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  textAlign: "center",
                  marginBottom: "5px"
                }}>
                  5 Star Reviews
                </div>
                <div style={{textAlign: "center"}}>
                  {[...Array(5)].map((_, i) => (
                    <span key={i} style={{color: "#fff", fontSize: "16px"}}>★</span>
                  ))}
                </div>
              </div>
            </a>
          </div>

          {/* Contact Form - Centered */}
          <div style={{
            position: "relative",
            zIndex: 200,
            width: "90%",
            maxWidth: "500px"
          }}>
            <div className="primary-background" style={{
              padding: "40px 30px",
              borderRadius: "4px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.3)"
            }}>
              {/* Form Header */}
              <div className="white centered-text" style={{marginBottom: "30px"}}>
                <h2 className="white" style={{margin: "0 0 10px 0", fontSize: "2.5em"}}>Free Estimates</h2>
                <h3 className="white" style={{margin: "0", fontSize: "1.8em", fontWeight: "bold"}}>(650) 255-4768</h3>
              </div>

              {/* Success Message */}
              {this.state.isSubmitted && (
                <div className="white centered-text" style={{
                  padding: "20px",
                  backgroundColor: "rgb(255, 87, 34)",
                  borderRadius: "8px",
                  marginBottom: "20px"
                }}>
                  <h4 className="white">Thank you!</h4>
                  <p className="white">Your message has been sent successfully. We'll get back to you soon!</p>
                </div>
              )}

              {/* Contact Form */}
              <form onSubmit={this.handleSubmit}>
                <div style={{marginBottom: "20px"}}>
                  <label className="white" style={{display: "block", marginBottom: "8px", fontSize: "16px"}}>Name</label>
                  <input 
                    type="text" 
                    name="name"
                    value={this.state.formData.name}
                    onChange={this.handleInputChange}
                    className="full-width" 
                    style={{
                      padding: "12px 15px",
                      borderRadius: "6px",
                      border: "1px solid #ccc",
                      fontSize: "16px"
                    }}
                    required
                  />
                </div>

                <div style={{marginBottom: "20px"}}>
                  <label className="white" style={{display: "block", marginBottom: "8px", fontSize: "16px"}}>Email Address</label>
                  <input 
                    type="email" 
                    name="email"
                    value={this.state.formData.email}
                    onChange={this.handleInputChange}
                    className="full-width" 
                    style={{
                      padding: "12px 15px",
                      borderRadius: "6px",
                      border: "1px solid #ccc",
                      fontSize: "16px"
                    }}
                    required
                  />
                </div>

                <div style={{marginBottom: "20px"}}>
                  <label className="white" style={{display: "block", marginBottom: "8px", fontSize: "16px"}}>Phone Number</label>
                  <input 
                    type="tel" 
                    name="phone"
                    value={this.state.formData.phone}
                    onChange={this.handleInputChange}
                    className="full-width" 
                    style={{
                      padding: "12px 15px",
                      borderRadius: "6px",
                      border: "1px solid #ccc",
                      fontSize: "16px"
                    }}
                    required
                  />
                </div>

                <div style={{marginBottom: "30px"}}>
                  <label className="white" style={{display: "block", marginBottom: "8px", fontSize: "16px"}}>Message</label>
                  <textarea 
                    name="message"
                    value={this.state.formData.message}
                    onChange={this.handleInputChange}
                    className="full-width" 
                    rows="4"
                    style={{
                      padding: "12px 15px",
                      borderRadius: "6px",
                      border: "1px solid #ccc",
                      fontSize: "16px",
                      resize: "vertical"
                    }}
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  disabled={this.state.isSubmitting}
                  className="accent-background white full-width" 
                  style={{
                    padding: "15px 30px",
                    borderRadius: "4px",
                    fontSize: "18px",
                    fontWeight: "bold",
                    border: "none",
                    cursor: this.state.isSubmitting ? "not-allowed" : "pointer",
                    opacity: this.state.isSubmitting ? 0.7 : 1
                  }}
                >
                  {this.state.isSubmitting ? "Sending..." : "Submit"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/contact/index.js